var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portal_details"},[_c(_vm.currentFrame,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }